<template>
  <div class="relative">
    <div class="flex items-center mb-4">
      <span class="iconfont icon-fenlei"></span>
      <div class="text-lg ml-3">
        <slot>{{ $t("所有分类") }}</slot>
      </div>
    </div>
    <el-row :gutter="20" class="items-start justify-start flex-row text-sm">
      <el-col :offset="0" v-for="item in items1" :key="item.id"
        class="mb-0.83rem w-15rem  flex justify-between items-center ">
        <div class="cursor-pointer flex items-center space-x-2 flex-nowrap w-3/4 truncate" @click="toProduct(item.id)">
          <img :src="$firstImage(item.image, 'small')" alt="" class="w-7 h-7 img" :onerror="defaultUrl" />
          <span class="h-7 text-left flex items-center ">{{
            item.name
          }}</span>
        </div>
        <div class="iconfont icon-xiangshang right"></div>
      </el-col>
      <el-col :offset="0" class="mb-0.83rem w-15rem   ">
        <div class="cursor-pointer flex justify-between items-center "  @mouseover="showMore = true"  @click="$goTo('/product?classify_id=0')">
          <div class=" flex items-center space-x-2 flex-nowrap w-3/4 truncate"
           >
            <img src="https://cdn-qn.huaeb.com/sellmall/U2o9X1/20230323/FrLRuyPAiP9KMA6JVDrjAwakbQlD.png" alt=""
              class="w-7 h-7 img" :onerror="defaultUrl" />
            <span class="h-7 text-left flex items-center ">{{ $t('更多类别') }}</span>
          </div>
          <div class="iconfont icon-xiangshang right" ></div>
        </div>
      </el-col>
      <!-- <router-link :to="{ name: 'Product', query: { classify_id: 0 } }">• • •</router-link> -->
    </el-row>
    <div class="pop" v-if="showMore && items2 && items2.length" @mouseleave="showMore = false">
        <div v-for="item in items2" :key="item.id" class="flex items-center justify-between cursor-pointer"
          @click="toProduct(item.id)">
          <span class="block w-3/4 truncate text-left">{{ item.name }}</span>
          <span class="iconfont icon-xiangshang right text-xs"></span>
        </div>
    </div>
  </div>
</template>

<script>
import { computed, ref,watch,onMounted } from "@vue/composition-api"
export default {
  setup(props, ctx) {
    const items = ref()
    const getClassifyList = async() => {
      let res = await ctx.root.$callapi('pre/getClassifyList')
      if (res.code == 0 && res.data) {
        items.value = res.data.items
      }
    }
    onMounted(async() => {
      isLoad.value = true
      await getClassifyList()
      isLoad.value = false
    })
    const items1 = computed(() => {
      return items.value?.slice(0, 7)
    })
    const items2 = computed(() => {
      return items.value?.slice(7,20)
    })
    const defaultUrl = 'this.src="' + require("@/assets/image/logo1.png") + '"';
    const user = computed(() => {
      return ctx.root.$store.getters.user;
    })
    const isLoad = ref(false)
    watch(() => user.value.user_lock_address, async () => {
      if (isLoad.value) return
      await getClassifyList()
    })
    const toProduct = (id) => {
      ctx.root.$router.push({
        name: "Product",
        query: { classify_id: id },
      });
    };
    const showMore = ref(false)

    return { items, toProduct, defaultUrl, items1, items2, showMore };
  },
};
</script>
<style scoped lang="scss">.right {
  display: block;
  transform: rotate(90deg);
  color: #909090;
}
.pop > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.pop {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  position: absolute;
  bottom: -0.5rem;
  left: 14.5rem;
  width: 12.8rem;
  z-index: 10;
  color: #666666;
  border-radius: 0.5rem;
}</style>
